/**
 * Bodi referral leaderboard (owner view). Key-gated: the edge function
 * rejects everything without the LEADERBOARD_KEY, so this page renders
 * nothing sensitive until a valid key is entered (kept in sessionStorage).
 */
(function () {
  'use strict';

  var KEY_STORE = 'bodi_lb_key';

  function init() {
    var root = document.querySelector('[data-bodi-leaderboard]');
    if (!root) return;
    var endpoint = root.getAttribute('data-endpoint');
    var gate = root.querySelector('[data-lb-gate]');
    var board = root.querySelector('[data-lb-board]');
    var errorEl = root.querySelector('[data-lb-error]');

    function showGate(withError) {
      gate.classList.remove('hidden');
      board.classList.add('hidden');
      if (errorEl) errorEl.classList.toggle('hidden', !withError);
    }

    function load(key) {
      fetch(endpoint + '?leaderboard=1', { headers: { 'x-admin-key': key } })
        .then(function (res) {
          if (res.status === 401) throw new Error('unauthorised');
          return res.json();
        })
        .then(function (data) {
          if (!data || !data.ok) throw new Error('bad response');
          try { sessionStorage.setItem(KEY_STORE, key); } catch (e) { /* fine */ }
          render(data);
        })
        .catch(function () {
          try { sessionStorage.removeItem(KEY_STORE); } catch (e) { /* fine */ }
          showGate(true);
        });
    }

    function render(data) {
      gate.classList.add('hidden');
      board.classList.remove('hidden');

      root.querySelector('[data-lb-total]').textContent = data.total;
      root.querySelector('[data-lb-referred]').textContent = data.referred;
      var top = data.rows.length && data.rows[0].referrals > 0 ? data.rows[0] : null;
      root.querySelector('[data-lb-top]').textContent = top
        ? (top.first_name || top.email.split('@')[0]) + ' · ' + top.referrals
        : '–';

      var body = root.querySelector('[data-lb-rows]');
      var tpl = root.querySelector('template[data-lb-row]');
      body.textContent = '';
      data.rows.forEach(function (r, i) {
        var row = tpl.content.firstElementChild.cloneNode(true);
        row.querySelector('[data-r-rank]').textContent = i + 1;
        row.querySelector('[data-r-name]').textContent = r.first_name || '—';
        row.querySelector('[data-r-email]').textContent = r.email;
        row.querySelector('[data-r-code]').textContent = r.code;
        row.querySelector('[data-r-source]').textContent = r.source + (r.was_referred ? ' · via friend' : '');
        row.querySelector('[data-r-joined]').textContent = new Date(r.joined).toLocaleDateString('en-NZ', { day: 'numeric', month: 'short' });
        var count = row.querySelector('[data-r-count]');
        count.textContent = r.referrals;
        count.className += r.referrals > 0
          ? ' bg-[#FAD11B] text-[#144634]'
          : ' bg-charcoal/5 text-charcoal/40';
        body.appendChild(row);
      });
    }

    var form = root.querySelector('[data-lb-form]');
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var key = form.querySelector('input').value.trim();
      if (key) load(key);
    });

    var lock = root.querySelector('[data-lb-lock]');
    if (lock) {
      lock.addEventListener('click', function () {
        try { sessionStorage.removeItem(KEY_STORE); } catch (e) { /* fine */ }
        showGate(false);
      });
    }

    var saved = null;
    try { saved = sessionStorage.getItem(KEY_STORE); } catch (e) { /* fine */ }
    if (saved) load(saved);
    else showGate(false);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
